import { Outlet } from 'react-router-dom';
import { DashboardSidebar } from '@/components/DashboardSidebar';
import { DashboardHeader } from '@/components/DashboardHeader';
import TrialBanner from '@/components/TrialBanner';
import PostTrialBanner from '@/components/PostTrialBanner';

/**
 * Shared layout for all dashboard pages.
 * Renders the sidebar and header once — child pages render via <Outlet />.
 * This prevents the sidebar (and its fox logo) from re-mounting on navigation.
 */
const DashboardLayout = () => {
  return (
    <div className="h-screen bg-background flex w-full overflow-hidden">
      {/* Skip to content link for keyboard users */}
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-[100] focus:px-4 focus:py-2 focus:bg-primary focus:text-primary-foreground focus:rounded-lg focus:shadow-lg focus:outline-none focus:ring-2 focus:ring-ring"
      >
        Przejdź do treści
      </a>

      <DashboardSidebar />

      <div className="flex-1 flex flex-col min-w-0 overflow-y-auto pt-16 md:pt-0">
        <TrialBanner />
        <PostTrialBanner />
        <DashboardHeader />
        <div id="main-content" tabIndex={-1}>
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default DashboardLayout;
